import { apiClient } from '@/lib/api-client'
import type { WeeklyMealPlan, AssignMealSlotPayload, UpdateServingMultiplierPayload, RemoveMealSlotPayload, SuggestMealSlotPayload, SuggestionActionPayload, MealSlot } from './types'

export const mealPlanService = {
  getWeeklyMealPlan: (weekStartDate: string): Promise<WeeklyMealPlan> =>
    apiClient.get(`/api/v1/meal-plan?weekStartDate=${weekStartDate}`),

  assignMealSlot: ({ weekStartDate, dayOfWeek, recipeId }: AssignMealSlotPayload): Promise<MealSlot> =>
    apiClient.put(`/api/v1/meal-plan/slots/${dayOfWeek}`, { weekStartDate, recipeId }),

  updateServingMultiplier: ({ weekStartDate, dayOfWeek, servingMultiplier }: UpdateServingMultiplierPayload): Promise<MealSlot> =>
    apiClient.patch(`/api/v1/meal-plan/slots/${dayOfWeek}/serving-multiplier`, { weekStartDate, servingMultiplier }),

  removeMealSlot: ({ weekStartDate, dayOfWeek }: RemoveMealSlotPayload): Promise<void> =>
    apiClient.delete(`/api/v1/meal-plan/slots/${dayOfWeek}?weekStartDate=${weekStartDate}`),

  suggestMealSlot: ({ weekStartDate, dayOfWeek, recipeId }: SuggestMealSlotPayload): Promise<MealSlot> =>
    apiClient.post(`/api/v1/meal-plan/slots/${dayOfWeek}/suggestion`, { weekStartDate, recipeId }),

  approveSuggestion: ({ weekStartDate, dayOfWeek }: SuggestionActionPayload): Promise<MealSlot> =>
    apiClient.post(`/api/v1/meal-plan/slots/${dayOfWeek}/suggestion/approve`, { weekStartDate }),

  dismissSuggestion: ({ weekStartDate, dayOfWeek }: SuggestionActionPayload): Promise<void> =>
    apiClient.post(`/api/v1/meal-plan/slots/${dayOfWeek}/suggestion/dismiss`, { weekStartDate }),
}
